import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockLegalAdviceContractAnalysis');

@I18nHoc(translates())
export default class LegalAdviceContractAnalysisBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={i18n('imgPDF4')} alt={i18n('legalAdviceContractAnalysisAlt')} loading="lazy" decoding="async" />
            </div>
          </Col>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h2')}><h2 children={i18n('legalAdviceContractAnalysisH2')} /></div>
            <Trans lang="ru">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('text', 'h3')}>
                    <h3 children="Каждый детальный отчёт о надёжности ЖК содержит:" />
                  </div>
                  <ul {...classes('list', 'withSquare')}>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="юридическую консультацию по предлагаемой застройщиком схеме инвестирования" />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="анализ инвестиционного договора на предмет наличия в нём главных пунктов" />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="информацию о налогах, сборах, дополнительных расходах инвестора" />
                      </div>
                    </li>
                  </ul>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Всего застройщики Украины применяют 10 схем инвестирования, 4 из которых прямо предусмотрены ст. 4 Закона Украины об инвестиционной деятельности, а остальные нет. В рамках отчёта о надёжности новостройки вы получаете консультацию по той схеме, которую предлагает застройщик, выбранного вами ЖК." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Юридическая консультация полностью прояснит ваши будущие правоотношения с застройщиком, покажет выгоды и предостережения, обратит внимание на важные моменты." />
                  </div>
                </li>
              </ul>
            </Trans>
            <Trans lang="ua">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('text', 'h3')}>
                    <h3 children="Кожен детальний звіт про надійність ЖК містить:" />
                  </div>
                  <ul {...classes('list', 'withSquare')}>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="юридичну консультацію за пропонованою забудовником схемою інвестування" />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="аналіз інвестиційного договору на предмет наявності в ньому головних пунктів" />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text')} children="інформацію про податки, збори, додаткові витрати інвестора" />
                      </div>
                    </li>
                  </ul>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Усього забудовники України застосовують 10 схем інвестування, 4 з яких безпосередньо передбачені ст. 4 Закону України про інвестиційну діяльність, а інші ні. У рамках звіту про надійність новобудови ви отримуєте консультацію за тією схемою, яку пропонує забудовник, обраного вами ЖК." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Юридична консультація повністю з’ясує ваші майбутні правовідносини із забудовником, вкаже на вигоди і застереження, зверне увагу на важливі моменти." />
                  </div>
                </li>
              </ul>
            </Trans>
          </Col>
        </Row>
      </div>
    );
  }
}
